import React from 'react';


function Mobile() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20">
      <title>mobile icon</title>
      <path fill="#FFF" fillRule="nonzero" d="M1.364 0A1.37 1.37 0 0 0 0 1.364v17.272A1.37 1.37 0 0 0 1.364 20h9.09a1.37 1.37 0 0 0 1.364-1.364V1.364A1.37 1.37 0 0 0 10.455 0H1.364zM.909 3.182h10v13.182h-10V3.182zm3.636 14.545h2.728a.455.455 0 0 1 0 .91H4.545a.455.455 0 0 1 0-.91z"/>
    </svg>
  );
}

export default Mobile;
